module.exports = __webpack_public_path__ + "static/media/google-logo.b5a6f501.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-logo.svg
// module id = 642
// module chunks = 0